// extracted by mini-css-extract-plugin
module.exports = {"fontCompactaCom":"YoungWashingtonView_fontCompactaCom__czbCT"};